module.exports = __webpack_public_path__ + "static/87-a67d16ec0a1d140484f9e608a53c0b6a.png";